import {
	distinctColours,
	statisticsCountrySelectionKey,
} from '../../constants/app';

export default {
	key: statisticsCountrySelectionKey,
	data: {
		colourPalette: distinctColours,
		distinctItems: true,
		featureKeysFilter: {
			keys: [],
		},
		style: {
			outlineWidth: 3,
			outlineColor: '#25ccff',
			outlineOpacity: 1,
			fill: '#25ccff',
			fillOpacity: 0.5,
		},
	},
};
